"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notifications = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var IFramePopover_1 = require("./IFramePopover");
var iFrameHelper_1 = require("./iFrameHelper");
var NumberOfNotificationsBadge_1 = require("./NumberOfNotificationsBadge");
var ActionBarItem_1 = __importDefault(require("@rio-cloud/rio-uikit/lib/es/ActionBarItem"));
var useOnScreen_1 = __importDefault(require("@rio-cloud/rio-uikit/lib/es/useOnScreen"));
var URL = 'https://platform-notifications.rio.cloud';
var URL_LOCAL = 'http://localhost:3000';
var MessageType;
(function (MessageType) {
    MessageType["NOTIFICATIONS_POPOVER_CLOSED"] = "NOTIFICATIONS_POPOVER_CLOSED";
    MessageType["NOTIFICATIONS_POPOVER_OPENED"] = "NOTIFICATIONS_POPOVER_OPENED";
})(MessageType || (MessageType = {}));
var Notifications = function (_a) {
    var useLocalSpa = _a.useLocalSpa;
    var isRunningInProduction = process.env.NODE_ENV === 'production';
    var _b = (0, react_1.useState)(isRunningInProduction), isLoading = _b[0], setIsLoading = _b[1];
    var _c = (0, react_1.useState)(0), numberOfNewNotifications = _c[0], setNumberOfNewNotifications = _c[1];
    var _d = (0, react_1.useState)('LOW'), priority = _d[0], setPriority = _d[1];
    var _e = (0, react_1.useState)(false), hasBeenViewed = _e[0], setHasBeenViewed = _e[1];
    var ref = (0, react_1.useRef)();
    var inView = (0, useOnScreen_1.default)(ref);
    var sendMessageToParentIframe = function (messageType) {
        var ifr = document.getElementById('platform-notification-iframe');
        if (ifr && (0, iFrameHelper_1.isIFrame)(ifr)) {
            ifr.contentWindow.postMessage({ type: messageType }, '*');
        }
    };
    (0, react_1.useEffect)(function () {
        if (inView && !isLoading) {
            sendMessageToParentIframe(MessageType.NOTIFICATIONS_POPOVER_OPENED);
            setHasBeenViewed(true);
        }
        else if (!inView && hasBeenViewed) {
            sendMessageToParentIframe(MessageType.NOTIFICATIONS_POPOVER_CLOSED);
        }
    }, [inView]);
    var iFrameUrl;
    if (isRunningInProduction) {
        iFrameUrl = URL;
    }
    else if (useLocalSpa) {
        iFrameUrl = URL_LOCAL;
    }
    var onMessage = function (event) {
        return (0, iFrameHelper_1.onIframeMessage)(event, {
            notificationCount: setNumberOfNewNotifications,
            notificationPriority: setPriority,
        }, iFrameUrl);
    };
    return ((0, jsx_runtime_1.jsxs)(ActionBarItem_1.default, { id: 'platformNotifications', popoverWidth: 400, children: [(0, jsx_runtime_1.jsxs)(ActionBarItem_1.default.Icon, { children: [(0, jsx_runtime_1.jsx)("span", { className: 'icon rioglyph rioglyph-notification' }), (0, jsx_runtime_1.jsx)(NumberOfNotificationsBadge_1.NumberOfNotificationsBadge, { count: numberOfNewNotifications, priority: priority })] }), (0, jsx_runtime_1.jsx)(ActionBarItem_1.default.Popover, { className: 'padding-0', useOffscreen: true, children: (0, jsx_runtime_1.jsx)(IFramePopover_1.IFramePopoverWrapper, { iFrameUrl: iFrameUrl, isLoading: isLoading, setIsLoading: setIsLoading, onMessage: onMessage, innerRef: ref }) })] }));
};
exports.Notifications = Notifications;
